import React from 'react'
import View from './AllGalleries.view'
import { useGalleryContext } from 'context/Gallery'
import Footer from 'components/Footer'

export default function AllGalleriesLogic() {
  const { galleries, filter } = useGalleryContext()
  return (
    <>
      <View galleries={galleries} filter={filter} />
      <Footer />
    </>
  )
}
